module.exports = __webpack_public_path__ + "static/media/LTL_package_inactive.8b971c95.svg";